import { createPortal } from 'react-dom';
import { EnumUrlsPages } from '../../services/Enum';

export const SchemaJsonBreadcrumbList = ({
  title,
  section,
}: {
  title: string;
  section: 'services' | 'blog';
}) => {
  let sectionLink = { id: '', name: '' };

  switch (section) {
    case 'services':
      sectionLink = { id: EnumUrlsPages.delivery, name: 'Услуги' };
      break;
    case 'blog':
      sectionLink = { id: EnumUrlsPages.live, name: 'Блог' };
      break;
    default:
      sectionLink = { id: '', name: '' };
  }

  return createPortal(
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@id": "${window.location.origin}/",
                "name": "Главная"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@id": "${window.location.origin}${sectionLink.id}",
                "name": "${sectionLink.name}"
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@id": "${window.location.href}",
                "name": "${title}"
              }
            }
          ]
        }`,
      }}
    ></script>,
    document.head
  );
};
